import getUserNameInitials from '../../utilities/getUserNameInitials';
import useUserDisplayName from './useUserDisplayName';

export default function useUserNameInitials() {
  const userDisplayName = useUserDisplayName();
  const userInitials = getUserNameInitials(userDisplayName);
  return userInitials;
}
